import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { css } from 'emotion';
import { useT } from 'client/i18n/hooks/useT';

export const DeleteMediaConfirmationModal = ({
  hideConfirmationModal,
  onDelete,
  deleteStatus,
}: {
  hideConfirmationModal: () => void;
  onDelete: () => void;
  deleteStatus: string;
}) => {
  const t = useT();
  return (
    <Modal
      isShowing
      onClose={hideConfirmationModal}
      aria-labelledby="delete-media-confirmation-modal-title"
      size="small"
    >
      <Modal.Title id="delete-media-confirmation-modal-title">
        {t(
          'EpisodeOptionsScreen.EpisodeContent.DeleteMediaConfirmationModal.Title',
          'Delete this audio?',
          'Delete media confirmation modal title'
        )}
      </Modal.Title>
      <Modal.Body>
        {t(
          'EpisodeOptionsScreen.EpisodeContent.DeleteMediaConfirmationModal.Message',
          'This action will remove all media content associated with your episode.',
          'Delete media confirmation modal message'
        )}
      </Modal.Body>
      {deleteStatus === 'error' && (
        <Modal.Error>
          {t(
            'EpisodeOptionsScreen.EpisodeContent.ErrorMessage',
            'Something went wrong. Please try again.',
            'Generic error meesage'
          )}
        </Modal.Error>
      )}
      <Modal.Footer>
        <ButtonPrimary
          colorSet="negative"
          className={css`
            color: #ffffff !important;
          `}
          onClick={hideConfirmationModal}
        >
          {t('Button.Cancel', 'Cancel', 'Cancel button text')}
        </ButtonPrimary>
        <ButtonPrimary disabled={deleteStatus === 'loading'} onClick={onDelete}>
          {deleteStatus === 'loading'
            ? t('Button.Deleting', 'Deleting...', 'Deleting button text')
            : t('Button.Delete', 'Delete', 'Delete button text')}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};
